import React, { useEffect, useState } from 'react';

import classes from './Attendance.module.scss';
import { fetchAttendance } from '../../../../../../API/API';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

const Attendance = () => {

  const arr = [
    { name: "Krishna", email: "krishna@gmail.com" },
    { name: "Vishwa", email: "Vishwa@gmail.com" },
    { name: "Ananya", email: "Ananya@gmail.com" },
  ]

  let table = document.createElement('table');
  arr.forEach((item) => {
    let tr = document.createElement("tr");
    let td1 = document.createElement('td');
    let td2 = document.createElement('td');
    tr.append(td1);
    tr.append(td2);

    table.appendChild(tr)
  }
  )

  document.innerHTML = table

  const [viewAtt, setViewAtt] = useState([])
  const state = useSelector(state => state.login)

  useEffect(() => {

    const openAttendanceTab = async () => {
      const userID = localStorage.getItem('userID')
      const data = JSON.parse(localStorage.getItem('data'));
      if (userID !== null) {
        const date = new Date();
        const fifteenDaysAgo = new Date();
        fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 15);

        const currentDate = date.toISOString().substring(0, 10);
        const newDate = fifteenDaysAgo.toISOString().substring(0, 10);

        try {
          const response = await fetchAttendance(userID, data.empid, data.token, newDate, currentDate);
          setViewAtt(response.data);
        }
        catch (error) {
          toast(error.message, {
            icon: '❗',
            duration: 4500
          });
        }
      } else {
        toast('Problem In Fetching Attendance', {
          icon: '❗',
          duration: 4500
        });
      }
    }

    openAttendanceTab();
  }, [state.closeCheckIn, state.closeCheckOut])

  return (
    <div className={classes.Attendance}>
      <h2>Attendance For Last 15 Days</h2>
      <div className={classes.TableDiv}>
        <table cellSpacing={0}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Check In</th>
              <th>Check Out</th>
            </tr>
          </thead>
          <tbody>
            {viewAtt.map((item, index) => {
              return (

                <tr key={index}>
                  {item.flag === "ABS" ?
                    <>
                      <td>{item.dt.substring(5).split('-').reverse().join('/')}</td>
                      <td style={{ color: "#EA6A47" }}>Absent</td>
                      <td style={{ color: "#EA6A47" }}>Absent</td>
                    </>
                    : (item.flag === 'GH' ?
                      <>
                        <td>{item.dt.substring(5).split('-').reverse().join('/')}</td>
                        <td style={{ color: "#1C4E80" }} >{item.holiday}</td>
                        <td style={{ color: "#1C4E80" }} >{item.holiday}</td>
                      </>
                      : (item.flag === 'LV' ? <>
                        <td>{item.dt.substring(5).split('-').reverse().join('/')}</td>
                        <td style={{ color: "#EA6A47" }} >{item.leave}</td>
                        <td></td>
                      </> : item.flag === 'WO' ?
                        <>
                          <td>{item.dt.substring(5).split('-').reverse().join('/')}</td>
                          <td style={{ color: "#EA6A47" }} >Weekend Off</td>
                          <td style={{ color: "#EA6A47" }} >Weekend Off</td>
                        </> :
                        <>
                          < td >
                            <div>{item.dt.substring(5).split('-').reverse().join('/')}</div>
                          </td >
                          <td >
                            {item.in_time === null || item.in_from === null ?
                              <span style={{ color: '#EA6A47' }}>Not Checked In</span>
                              : <div>
                                {`${item.in_from.replace(/_/g, " ").substring(0, 11)}...`}
                                <br />
                                {item.in_time}
                              </div>}

                          </td>
                          <td>
                            {item.out_time === null ?
                              <span style={{ color: '#EA6A47' }}>Not Checked Out</span>
                              : <div>
                                {`${item.out_from.replace(/_/g, " ").substring(0, 11)}...`}
                                <br />
                                {item.out_time}
                              </div>}
                          </td>
                        </>
                      ))
                  }
                </tr>

              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Attendance